(async () => {
    const { Core } = await importModule('Core');

    const BUY_WITH_IDS = ['buy_with_1', 'buy_with_2'];

    customElements.define('product-form', class extends Core {

        elements = {
            form: '[data-to-cart-form]',
            toCartButton: 'product-to-cart'
        }

        render() {
            this.$form?.addEventListener('submit', this._submitHandler.bind(this))
        }

        _submitHandler(e) {
            e.preventDefault();
            this.$toCartButton.addToCart(this.cartItems, this.mainVariantId)
        }

        _isVariantInput([ inputName, value ]) {
            if (inputName === 'selling_plan') this._setSellingPlan(value);
            return BUY_WITH_IDS.includes(inputName) || inputName === 'id';
        }
        
        _setSellingPlan(id) {
            this.sellingPlanId = id;
        }

        _setCartItem([ inputName, value ]) {
            if (inputName === 'id') this.mainVariantId = value;
            const sellingPlanId = this.sellingPlanId || '';
            return {
                id: value,
                quantity: this._getItemQty(inputName),
                selling_plan: inputName === 'id' ? sellingPlanId : ''
            }
        }

        _getItemQty(inputName) {
            return inputName === 'id' ? this.qty : 1;
        }

        get cartItems() {
            return Array.from(this.formData.entries())
                .filter(this._isVariantInput.bind(this))
                .map(this._setCartItem.bind(this))
        }

        get formData() {
            return new FormData(this.$form);
        }

        get qty() {
            return +this.formData.get('quantity') || 1;
        }
    })
})();